import React, { Component } from 'react'
import './index.less'
interface StoreInfoProps {
  store?: string
  tel?: string
  address?: string
}
export default class StoreInfo extends Component<StoreInfoProps> {
  render() {
    return (
      <div className="store-info">
        <div>
          <img className='store-img' src='/public/assets/img/store_icon.png' alt="" />
        </div>
        <div className='store-info-content'>
          <div>
            <span className='store-info-name'>{this.props.store}</span>
            <span className='store-info-tel'>{this.props.tel}</span>
          </div>
          <div className='store-info-address'>
            <span>{this.props.address}</span>
          </div>
        </div>
      </div>
    )
  }
}